import React from "react";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import "../sda/styles.scss";
import { Card } from "@amzn/stencil-react-components/card";
import { Text } from "@amzn/stencil-react-components/text";
import { Link } from "@amzn/stencil-react-components/link";

const linkStyle = {
  cursor: "pointer",
};

interface ManageApplicationCardHeaderProps {
  jobTitle?: string;
  hours?: string;
  startDate?: string;
  startTime?: string;
  description?: string;
  address?: string;
  payRate?: string;
  image?: string;
  startDateStatus?: string;
  onChangeScheduleClick: () => void;
  eligibleForCSS: boolean;
}

export const ManageApplicationCardHeader = ({
  jobTitle,
  hours,
  startDate,
  startTime,
  description,
  address,
  payRate,
  image,
  startDateStatus,
  onChangeScheduleClick,
  eligibleForCSS,
}: ManageApplicationCardHeaderProps) => {
  const startDateText =
    startDateStatus === "TENTATIVE" ? (
      <Text fontSize="T200">Tentative Start date:</Text>
    ) : (
      <Text fontSize="T200">Start date:</Text>
    );

  const hourText = hours ? hours.split("\n") : [];

  const card = (
    <Card>
      <Col>
        <Row alignItems="center">
          <Col padding="1rem">
            <img alt={"Icon"} src={image} width="80px" />
          </Col>

          <Col padding="1rem" gridGap="0.2rem">
            <Text fontSize="T200" fontWeight="bold" id="schedule-card-jobTitle">
              {jobTitle}
            </Text>
            <Text fontSize="T200" id="schedule-card-hours">
              {description}
            </Text>
          </Col>
        </Row>
        <Row padding="0.2rem">
          <Col padding="0.2rem">
            <Text fontSize="T200">Shift:</Text>
          </Col>
          <Col padding="0.2rem">
            <Text fontSize="T200">
              {hourText.map((text: string) => (
                <Row key={text}>{text}</Row>
              ))}
            </Text>
          </Col>
        </Row>
        <Row padding="0.2rem">
          <Col padding="0.2rem">
            <Text fontSize="T200">Pay rate:</Text>
          </Col>
          <Col padding="0.2rem">
            <Text fontSize="T200" id="schedule-card-pay-rate">
              ${payRate}/hr
            </Text>
          </Col>
        </Row>

        <Row padding="0.2rem">
          <Col padding="0.2rem">{startDateText}</Col>
          <Col padding="0.2rem">
            <Text fontSize="T200" id="schedule-card-start-date">
              {startDate}, {startTime}
            </Text>
          </Col>
        </Row>

        <Row padding="0.2rem">
          <Col padding="0.2rem">
            <Text fontSize="T200">Work address:</Text>
          </Col>
          <Col padding="0.2rem">
            <Text fontSize="T200" id="schedule-card-address">
              {address}
            </Text>
          </Col>
        </Row>

        {eligibleForCSS && (
          <Row padding="0.2rem">
            <Col padding="0.2rem">
              <Link
                textDecoration="none"
                style={linkStyle}
                onClick={onChangeScheduleClick}
              >
                <Text fontSize="T200">Change schedule and start date</Text>
              </Link>
            </Col>
          </Row>
        )}
      </Col>
    </Card>
  );

  return card;
};
